import {
    Action,
    handleActions,
} from 'redux-actions';
import {TimelineRow} from '../../../Timeline/TimelineTypes';
import {
    SUBTITLE_SET,
    SUBTITLES_RESET,
    SUBTITLE_ENABLE,
    SUBTITLE_DISABLE,
    SUBTITLE_DISABLE_ALL,
} from './SubtitleTracksActions';

export interface EnabledSubtitles {
    [key: string]: boolean;
}

export interface SubtitlesState {
    subtitles: TimelineRow[];
    enabled: EnabledSubtitles;
}

export const initialState: SubtitlesState = {
    subtitles: [],
    enabled: {},
};

export const ascendingCompare = (rowA: TimelineRow, rowB: TimelineRow) => {
    return rowA.label < rowB.label ? -1 : 1;
};

export const setSubtitle = (state: SubtitlesState, action: Action<TimelineRow>): SubtitlesState => {
    const {payload} = action;
    const subtitle = payload;

    if (!subtitle) {
        return state;
    }

    const updatedSubtitles = [...state.subtitles, subtitle];
    const subtitles = updatedSubtitles.sort(ascendingCompare);
    const languages = subtitles.map((subtitle) => subtitle.identifier);
    const enabled: EnabledSubtitles = {};

    for (const language of languages) {
        enabled[language] = true
    }

    return {
        ...state,
        subtitles,
        enabled,
    };
};

export const resetSubtitles = (): SubtitlesState => {
    return initialState;
};

export const setEnabledSubtitle = (state: SubtitlesState, action: Action<string>): SubtitlesState => {
    const {payload} = action;
    const language: string = payload;

    if (language) {
        return {
            subtitles: state.subtitles,
            enabled: {
                ...state.enabled,
                [language]: true,
            },
        };
    }
    return state;
};

export const setDisabledSubtitle = (state: SubtitlesState, action: Action<string>): SubtitlesState => {
    const {payload} = action;
    const language: string = payload;

    if (language) {
        return {
            ...state,
            enabled: {
                ...state.enabled,
                [language]: false,
            },
        };
    }
    return state;
};

export const disableAllSubtitles = (state: SubtitlesState): SubtitlesState => {
    return {
        ...state,
        enabled: {},
    };
};

const handlers = {
    [SUBTITLE_SET]: setSubtitle,
    [SUBTITLES_RESET]: resetSubtitles,
    [SUBTITLE_ENABLE]: setEnabledSubtitle,
    [SUBTITLE_DISABLE]: setDisabledSubtitle,
    [SUBTITLE_DISABLE_ALL]: disableAllSubtitles,
};

export default handleActions<SubtitlesState, any>(handlers, initialState);
